(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const navigationEntry = performance.getEntriesByType('navigation')[0];
  const isBackForward = navigationEntry?.type === 'back_forward';

  if (url.hash && isBackForward) {
    window.addEventListener(
      'load',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          const headerHeight =
            Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
          const top = card.getBoundingClientRect().top + window.scrollY - headerHeight - 12;
          window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
